import { defineComponent } from 'vue';

export default defineComponent({
  name: 'hadrianArbitraryTooltip',
  props: {
    enabled: {
      type: Boolean,
      default: true,
    },
    anchor: {
      type: String as () => 'left' | 'center' | 'right',
      default: 'right',
    },
    inset: {
      type: Boolean,
      default: false,
    },
    verticalPosition: {
      type: String as () => 'above' | 'below' | 'centered',
      default: 'below',
    },
  },
  computed: {
    tooltipOuterClasses(): string[] {
      return [
        `hadrian-arbitrary-tooltip__tooltip-outer--anchor-${this.anchor}`,
        `hadrian-arbitrary-tooltip__tooltip-outer--vertically-${this.verticalPosition}`,
        this.inset ? `hadrian-arbitrary-tooltip__tooltip-outer--inset` : '',
      ];
    },
  },
});
